module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "_pdv-48px"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_vm._v("\n        เป็น Atomic Class ที่ใช้กำหนดการพฤติกรรมของ Overflow Content ประกอบด้วย\n      ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "anchor",
    attrs: {
      "id": "atomic-overflow"
    }
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        Overflow ใช้กำหนดการจัดการ Overflow Content\n      ")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "anchor",
    attrs: {
      "id": "atomic-overflow"
    }
  }), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        Text Overflow ใช้กำหนดการจัดการ Overflow ของ Text ใน Container\n      ")]), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _vm._m(19), _vm._v(" "), _vm._m(20), _vm._v(" "), _vm._m(21), _vm._v(" "), _vm._m(22), _vm._v(" "), _vm._m(23), _vm._v(" "), _vm._m(24), _vm._v(" "), _c('hr', {
    staticClass: "_opct-30 _mgbt-32px"
  }), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _jtfct-spbtw"
  }, [_c('div', [_c('h5', {
    staticClass: "_mgbt-16px"
  }, [_vm._v("ก่อนหน้า")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'AtomicOpacity'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-left _fs-5"
  }), _vm._v("  Opacity\n          ")])], 1), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-16px _tal-r"
  }, [_vm._v("ต่อไป")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'AtomicPadding'
      }
    }
  }, [_vm._v("\n            Padding   "), _c('i', {
    staticClass: "fa fa-long-arrow-right _fs-5"
  })])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-2 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-overflow"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Overflow\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-128px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#atomic-overflow"
    }
  }, [_vm._v("Overflow")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#atomic-text-overflow"
    }
  }, [_vm._v("Text Overflow")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-3 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-overflow"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Overflow\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Class Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_ovf-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("overflow")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_ovfx-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("overflow")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_ovfy-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("overflow")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Value")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-32px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class Name")]), _vm._v(" "), _c('th', [_vm._v("Value")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_ovf-*")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_ovfx-*")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_ovfy-*")])])]), _vm._v(" "), _c('td', [_c('p', [_c('strong', [_vm._v("Keyword Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("vsb")]), _vm._v(" สำหรับ \"visible\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("at")]), _vm._v(" สำหรับ \"auto\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("hd")]), _vm._v(" สำหรับ \"hidden\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("sc")]), _vm._v(" สำหรับ \"scroll\"\n              ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Responsive:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-sm")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-md")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-lg")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_c('strong', [_vm._v("Hover:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-negative"
  }, [_c('strong', [_vm._v("No")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน overflow")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Overflow Visible -->\n<div class=\"_w-128px _ovf-vsb\">\n  <div class=\"_w-256px\"></div>\n</div>\n\n<!-- Overflow Hidden -->\n<div class=\"_w-128px _ovf-hd\">\n  <div class=\"_w-256px\"></div>\n</div>\n\n<!-- Overflow Auto -->\n<div class=\"_w-128px _ovf-at\">\n  <div class=\"_w-256px\"></div>\n</div>\n\n<!-- Overflow Scroll -->\n<div class=\"_w-128px _ovf-sc\">\n  <div class=\"_w-256px\"></div>\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _pst-rlt _mgbt-128px"
  }, [_c('div', [_vm._v("Overflow Visible")]), _vm._v(" "), _c('div', {
    staticClass: "_w-128px _h-64px _bgcl-neutral-300 _mgbt-32px _ovf-vsb"
  }, [_c('div', {
    staticClass: "_w-256px _h-24px _bgcl-neutral-500"
  })]), _vm._v(" "), _c('div', [_vm._v("Overflow Hidden")]), _vm._v(" "), _c('div', {
    staticClass: "_w-128px _h-64px _bgcl-neutral-300 _mgbt-32px _ovf-hd"
  }, [_c('div', {
    staticClass: "_w-256px _h-24px _bgcl-neutral-500"
  })]), _vm._v(" "), _c('div', [_vm._v("Overflow Auto")]), _vm._v(" "), _c('div', {
    staticClass: "_w-128px _h-64px _bgcl-neutral-300 _mgbt-32px _ovf-at"
  }, [_c('div', {
    staticClass: "_w-256px _h-24px _bgcl-neutral-500"
  })]), _vm._v(" "), _c('div', [_vm._v("Overflow Scroll")]), _vm._v(" "), _c('div', {
    staticClass: "_w-128px _h-64px _bgcl-neutral-300 _ovf-sc"
  }, [_c('div', {
    staticClass: "_w-256px _h-24px _bgcl-neutral-500"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-3 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-overflow"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Text Overflow\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Class Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_tovf-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("text-overflow")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Value")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-32px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class Name")]), _vm._v(" "), _c('th', [_vm._v("Value")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_tovf-*")])])]), _vm._v(" "), _c('td', [_c('p', [_c('strong', [_vm._v("Keyword Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("c")]), _vm._v(" สำหรับ \"clip\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("els")]), _vm._v(" สำหรับ \"ellipsis\"\n              ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Responsive:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-sm")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-md")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-lg")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-32px _fs-5"
  }, [_c('strong', [_vm._v("Hover:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-negative"
  }, [_c('strong', [_vm._v("No")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bio-message -primary _fs-6 _mgbt-64px"
  }, [_c('p', [_c('strong', [_vm._v("คำแนะนำ")]), _vm._v(" – Class "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_tovf-*")]), _vm._v("\n          นั้นจะต้องระบุ Style "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("white-space: nowrap")]), _vm._v("\n          เพื่อให้ Text Content ล้น Container ออกมา และ Style "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("overflow: hidden")]), _vm._v("\n          เพื่อซ่อน Text Content ที่ Overflow ด้วย จึงจะแสดงผลได้ 💁\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน text-overflow")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Normal Text Overflow -->\n<div>\n  <p class=\"_wsp-nw\">\n    Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n  </p>\n</div>\n\n<!-- Text Overflow Clip -->\n<div>\n  <p class=\"_wsp-nw _ovf-hd _tovf-c\">\n    Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n  </p>\n</div>\n\n<!-- Text Overflow Ellipsis -->\n<div>\n  <p class=\"_wsp-nw _ovf-hd _tovf-els\">\n    Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n  </p>\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _pst-rlt _mgbt-64px"
  }, [_c('h6', [_vm._v("Normal Text Overflow")]), _vm._v(" "), _c('div', {
    staticClass: "_w-128px _h-64px _bgcl-neutral-300 _mgbt-32px"
  }, [_c('p', {
    staticClass: "_wsp-nw"
  }, [_vm._v("\n            Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n          ")])]), _vm._v(" "), _c('h6', [_vm._v("Text Overflow Clip")]), _vm._v(" "), _c('div', {
    staticClass: "_w-128px _h-64px _bgcl-neutral-300 _mgbt-32px"
  }, [_c('p', {
    staticClass: "_wsp-nw _ovf-hd _tovf-c"
  }, [_vm._v("\n            Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n          ")])]), _vm._v(" "), _c('h6', [_vm._v("Text Overflow Ellipsis")]), _vm._v(" "), _c('div', {
    staticClass: "_w-128px _h-64px _bgcl-neutral-300"
  }, [_c('p', {
    staticClass: "_wsp-nw _ovf-hd _tovf-els"
  }, [_vm._v("\n            Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n          ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ce2970a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/document-pages/AtomicOverflow.vue
// module id = 122
// module chunks = 0